export default "__VITE_ASSET__BP_0y8yI__"